module.exports = __webpack_public_path__ + "static/media/address_image.a9e33809.svg";